export const CaseFilterMap = {
  TELEMEDICINE_CATEGORY_ID: 'teleMedicineCategoryId',
  STATE_ID: 'stateId',
  CASE_ID: 'caseId',
  PATIENT_FIRST_NAME: 'patientFirstName',
  PATIENT_LAST_NAME: 'patientLastName',
  TYPE: 'type',
  CREATED_DATE: 'createdDate',
  UPDATED_DATE: 'updatedDate',
  CREATED_DATE_RANGE: 'createdDateRange',
  UPDATED_DATE_RANGE: 'updatedDateRange',
  COMPLETED_DATE_RANGE: 'completedDateRange',
  STATUS: 'status',
  CASE_TAGS: 'caseTags',
  BOOKMARKED: 'bookmarked',
  PHYSICIAN_ID: 'physicianId',
  ADDITIONAL_STATUS: 'additional-status',
}

export const CaseQueryParamMap = {
  TELEMEDICINE_CATEGORY_ID: 'telemedicine-category-id',
  STATE_ID: 'state-id',
  CASE_ID: 'case-id',
  PATIENT_FIRST_NAME: 'patient-first-name',
  PATIENT_LAST_NAME: 'patient-last-name',
  TYPE: 'type',
  CREATED_DATE: 'created-date',
  UPDATED_DATE: 'updated-date',
  CREATED_DATE_RANGE: 'created-date-range',
  UPDATED_DATE_RANGE: 'updated-date-range',
  COMPLETED_DATE_RANGE: 'completed-date-range',
  STATUS: 'status',
  CASE_TAGS: 'case-tags',
  BOOKMARKED: 'bookmarked',
  PHYSICIAN_ID: 'physician-id',
  ADDITIONAL_STATUS: 'additional-status',
  SEARCH_TERM: 'search-term',
  ADDITIONAL_STATUS: 'additional-status',
  CONSULTATION_START: 'consultation-start',
  LAST_UPDATED: 'last-updated',
}

export const CaseFilterToQueryParamMap = {
  [CaseFilterMap.TELEMEDICINE_CATEGORY_ID]: CaseQueryParamMap.TELEMEDICINE_CATEGORY_ID,
  [CaseFilterMap.STATE_ID]: CaseQueryParamMap.STATE_ID,
  [CaseFilterMap.CASE_ID]: CaseQueryParamMap.CASE_ID,
  [CaseFilterMap.PATIENT_FIRST_NAME]: CaseQueryParamMap.PATIENT_FIRST_NAME,
  [CaseFilterMap.PATIENT_LAST_NAME]: CaseQueryParamMap.PATIENT_LAST_NAME,
  [CaseFilterMap.TYPE]: CaseQueryParamMap.TYPE,
  [CaseFilterMap.CREATED_DATE]: CaseQueryParamMap.CREATED_DATE,
  [CaseFilterMap.UPDATED_DATE]: CaseQueryParamMap.UPDATED_DATE,
  [CaseFilterMap.CREATED_DATE_RANGE]: CaseQueryParamMap.CREATED_DATE_RANGE,
  [CaseFilterMap.UPDATED_DATE_RANGE]: CaseQueryParamMap.UPDATED_DATE_RANGE,
  [CaseFilterMap.COMPLETED_DATE_RANGE]: CaseQueryParamMap.COMPLETED_DATE_RANGE,
  [CaseFilterMap.STATUS]: CaseQueryParamMap.STATUS,
  [CaseFilterMap.CASE_TAGS]: CaseQueryParamMap.CASE_TAGS,
  [CaseFilterMap.BOOKMARKED]: CaseQueryParamMap.BOOKMARKED,
  [CaseFilterMap.PHYSICIAN_ID]: CaseQueryParamMap.PHYSICIAN_ID,
  [CaseFilterMap.ADDITIONAL_STATUS]: CaseQueryParamMap.ADDITIONAL_STATUS,
}
